import { Dialog, DialogContent, DialogHeading, Link, Typography } from 'omakase';
import { Faq } from 'components/business/landing-page/FaqLink';
import { StoreType } from '@tock/shared/utils/connect';
import { isEmpty, map } from 'es-toolkit/compat';
import { useSelector } from 'react-redux';
import FaqItem from 'components/business/faq/FaqItem';
import LoadingComponent from '@tock/shared/components/LoadingComponent';
import React, { useMemo } from 'react';

interface Props {
  onClose(): void;
  faqs: Faq[];
  loading: boolean;
}

const FaqModal: React.FC<Props> = ({ faqs, loading, onClose }) => {
  const { business } = useSelector((state: StoreType) => ({
    app: state.app,
    business: state.business,
  }));

  const businessName = useMemo(() => business.business?.name || 'This business', [business]);

  return (
    <Dialog
      aria-labelledby="faq_dialog"
      fullWidth
      open={true}
      onClose={onClose}
      data-testid="faq-modal"
    >
      <DialogHeading id="faq_dialog" onClose={onClose}>
        FAQs
      </DialogHeading>
      <DialogContent>
        <div className="Faqs">
          <div className="Faqs-section">
            <LoadingComponent isLoading={loading} isBallPulse={true}>
              {isEmpty(faqs) && (
                <div className="Faqs-item">
                  <h4 className="Faqs-itemHeading">
                    <Typography color="inherit" component="span" variant="heading03">
                      No current FAQs
                    </Typography>
                  </h4>
                  <p className="Faqs-itemContent">
                    <Typography color="inherit" component="span" variant="body02">
                      {businessName} has not added any frequently asked questions.
                    </Typography>
                  </p>
                </div>
              )}

              {!isEmpty(faqs) &&
                map(
                  faqs,
                  (faq: Faq, index: number) =>
                    faq && (
                      <FaqItem
                        key={faq.id || index}
                        answer={[faq.answer || '']}
                        question={faq.question || ''}
                      />
                    )
                )}
            </LoadingComponent>
          </div>

          <div className="Faqs-section">
            <div className="Faqs-item">
              <h4 className="Faqs-itemHeading">
                <Typography color="inherit" component="span" variant="heading04">
                  Have additional questions?
                </Typography>
              </h4>
              <p className="Faqs-itemContent">
                <Typography color="inherit" component="span" variant="body02">
                  If you have additional questions about Tock or your reservation, please visit the{' '}
                  <Link href="/help">Tock help</Link> page.
                </Typography>
              </p>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default FaqModal;
